import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import useStackListAnalytics from "../../useStackListAnalytics";
import useCellCopyAction from "../useCellCopyAction";
import { STACKS_COLUMN_ID } from "../constants";

const StacksTableBlueprintCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const isEmpty = !stack.blueprint;

  const copyAction = useCellCopyAction({
    column: STACKS_COLUMN_ID.BLUEPRINT,
    text: stack.blueprint?.name || "",
  });

  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [isEmpty, copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {stack.blueprint && (
        <TableCellLink
          variant="primary"
          onPress={() => trackAnalytics("Blueprint link clicked")}
          href={`/blueprint/${stack.blueprint.ulid}`}
          tooltip={`Stack created from blueprint ${stack.blueprint.name}`}
        >
          {stack.blueprint.name}
        </TableCellLink>
      )}
    </TableSimpleCell>
  );
};

export default StacksTableBlueprintCell;
